import styled from "styled-components";
import { theme } from "../styles";

export const FooterBar = styled.footer`
  padding: 48px 16px;
  border-top: 1px solid ${theme.border};
  background: hsl(var(--hp-card) / 0.5);

  @media (min-width: 768px) {
    padding: 64px 24px;
  }
`;

export const FooterContainer = styled.div`
  width: 100%;
  max-width: ${theme.maxWidth};
  margin: 0 auto;
`;

export const FooterCta = styled.div`
  margin-bottom: 48px;
  padding-bottom: 48px;
  border-bottom: 1px solid ${theme.border};
  text-align: center;

  @media (min-width: 768px) {
    margin-bottom: 64px;
    padding-bottom: 64px;
  }
`;

export const FooterCtaTitle = styled.h2`
  margin: 0 0 16px;
  color: ${theme.foreground};
  font-size: clamp(1.875rem, 4vw, 2.25rem);
  font-weight: 700;
  line-height: 1.2;

  span {
    background: linear-gradient(
      90deg,
      hsl(32 95% 55%) 0%,
      hsl(32 80% 45%) 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

export const FooterCtaLead = styled.p`
  margin: 0 auto 32px;
  max-width: 576px;
  color: ${theme.textMuted};
  font-size: 1rem;
  line-height: 1.6;
`;

export const FooterCtaButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 48px;
  padding: 0 40px;
  border: none;
  border-radius: var(--hp-radius, 0.75rem);
  background-image: var(--hp-gradient-gold);
  box-shadow: 0 4px 20px hsl(32 95% 55% / 0.4);
  color: hsl(var(--hp-primary-foreground));
  font-family: inherit;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: scale(1.03);
    box-shadow: 0 6px 30px hsl(32 95% 55% / 0.5);
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus-visible {
    outline: 2px solid hsl(var(--hp-primary));
    outline-offset: 3px;
  }

  @media (min-width: 640px) {
    width: auto;
  }
`;

export const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  margin-bottom: 48px;

  @media (min-width: 768px) {
    grid-template-columns: 2fr 1fr;
    gap: 48px;
  }
`;

export const FooterBrandCol = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FooterBrandLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  text-decoration: none;
  color: inherit;

  &:hover,
  &:focus,
  &:active,
  &:visited {
    text-decoration: none;
    color: inherit;
  }
`;

export const FooterLogo = styled.img`
  height: 32px;
  width: auto;
  object-fit: contain;
`;

export const FooterBrandText = styled.span`
  color: ${theme.foreground};
  font-size: 1.125rem;
  font-weight: 700;
`;

export const FooterBrandAccent = styled.span`
  color: ${theme.primary};
`;

export const FooterTagline = styled.p`
  margin: 0 0 16px;
  max-width: 320px;
  color: ${theme.textMuted};
  font-size: 0.875rem;
  line-height: 1.6;
`;

export const FooterSocial = styled.div`
  display: flex;
  gap: 16px;

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${theme.textMuted};
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: ${theme.primary};
    }

    .material-icons,
    i {
      font-size: 20px;
    }
  }
`;

export const FooterLinksCol = styled.div``;

export const FooterLinksHeading = styled.h4`
  margin: 0 0 16px;
  color: ${theme.foreground};
  font-size: 1rem;
  font-weight: 600;
`;

export const FooterLinksList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FooterLinkItem = styled.li`
  a {
    color: ${theme.textMuted};
    font-size: 0.875rem;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: ${theme.foreground};
    }
  }
`;

export const FooterBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 32px;
  border-top: 1px solid ${theme.border};

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const FooterCopyright = styled.p`
  margin: 0;
  color: ${theme.textMuted};
  font-size: 0.875rem;
`;

export const FooterDisclaimer = styled.p`
  margin: 0;
  max-width: 448px;
  color: ${theme.textMuted};
  font-size: 0.75rem;
  line-height: 1.5;
  text-align: center;

  @media (min-width: 768px) {
    text-align: right;
  }
`;
